export default __webpack_public_path__ + "static/media/image4.37c9c4c9.jpg";